<template>
  <el-menu-item
      :index="index"
      :route="route"
      class="el-menu-item__custom"
      :class="selectedMenuItemClass">
    <div
        class="menu-item__container"
        :class="upDownBorderClass"
        @mouseover="hover = true"
        @mouseleave="hover = false">
      <img
          :src="computedIcon"
          class="icon">
      <span class="description">{{ description }}</span>
    </div>
  </el-menu-item>
</template>

<script>
export default {
  name: "MenuItem",
  props: {
    index: {
      type: String,
      required: true,
    },
    route: {
      type: Object,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    iconHovered: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      hover: false,
    };
  },
  computed: {
    computedIcon() {
      const currentActiveIndex = this.$parent.activeIndex;
      const isSelectedMenuItem = currentActiveIndex === this.index;

      if (this.hover || isSelectedMenuItem) {
        return this.iconHovered;
      }

      return this.icon;
    },
    selectedMenuItemClass() {
      const currentActiveIndex = this.$parent.activeIndex;
      const isSelectedMenuItem = currentActiveIndex === this.index;

      if (isSelectedMenuItem) {
        return "el-menu-item__selected";
      }

      return "";
    },
    upDownBorderClass() {
      if (this.hover) {
        return "menu-item__up-down-border";
      }

      return "";
    },
  },
};
</script>

<style scoped>
.description {
  color: #424242;
  font-family: "Equip2" !important;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 24px;
}
.icon {
  max-width: 20px;
  max-height: 20px;
  margin-right: 18px;
  fill: #4c4c4c;
}

.el-menu-item__custom {
  height: 48px;
  padding-right: 0;
  padding-left: 0 !important;
}

.menu-item__container {
  padding-left: 20px;
  height: 48px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
}

.el-menu-item__selected {
  background-color: #eff8fc;
}

.el-menu-item:not(.is-active) {
  background-color: white;
}

.menu-item__up-down-border {
  border-top: #dee5ec 1px solid;
  border-bottom: #dee5ec 1px solid;
}
</style>
